export default __webpack_public_path__ + "static/media/focus-on-social.4a8f4604.svg";